import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from 'vue';
import { getCanvasElementIcon, getCanvasElementTitle } from '@/utils/elementsUtils';
import {
    canChangeElementLock as _canChangeElementLock,
    canChangeElementVisibility as _canChangeElementVisibility,
    isElementSolidBackground as _isElementSolidBackground
} from '@/components/Layers/utils';

import SvgIcon from '@/components/SvgIcon/SvgIcon.vue';
import EditableText from '@/components/EditableText/EditableText.vue';
import CLazy from '@/components/CLazy.vue';
import BaseLayersTreeItem from '../BaseLayersTreeItem.vue';
import type { ListElements } from '@/typings/customilyElements/layer';
import type { CanvasElement, ImagePlaceholderElement } from '@/typings/customilyElements/canvasElements';
import { useLayerTreeItem } from '@/components/Layers/composables/useLayerTreeItem';
import CButton from '@/components/shared/CButton';
import ElementsLinkModal from '@/components/DesignStudio/ElementsLinkModal.vue';
import store from '@/store';
import { ElementType, ValueFormat } from '@/typings/designStudio/sourceElementTypes';


export default /*#__PURE__*/_defineComponent({
  __name: 'LayersTreeItemElement',
  props: {
    item: null
  },
  setup(__props: any) {

const props = __props as {
    item: ListElements;
};



const {
    flags,
    isVisible,
    isLocked,
    onElementTitleChange,
    onVisibilityClick,
    onLockClick,
    onApplyLink,
    onUnlink
} = useLayerTreeItem({
    item: props.item
});

const showLinkModal = ref(false);
const selectedElement = computed(() => props.item.element);
const isPreviewStep = computed(() => flags.value?.isPreviewStep);

const canChangeElementLock = computed(() => _canChangeElementLock(props.item.element, isPreviewStep.value || false));

const canChangeElementVisibility = computed(() =>
    _canChangeElementVisibility(props.item.element, isPreviewStep.value || false)
);

const onLayerVisibilityClick = () => {
    onVisibilityClick();
};

const onLayerLockClick = () => {
    if (!flags.value?.isPreviewStep && _isElementSolidBackground(props.item.element)) {
        return;
    }
    onLockClick();
};

const isElementSolidBackground = computed(() => _isElementSolidBackground(props.item.element));

const elementTitle = computed(() => getCanvasElementTitle(props.item.element));

const getElementIcon = computed(() => getCanvasElementIcon(props.item.element));

const sources = computed<CanvasElement[]>(
    () =>
        //For now, only maps are allowed as source elements
        store.state.storeLayers?.canvas
            ?.getObjects()
            .filter(
                (o): o is CanvasElement => o.type === 'image-placeholder' && !!(o as ImagePlaceholderElement)?.mapConfig
            ) ?? []
);

const showLinkButton = computed(() => {
    //  show button if there are available sources and the element is of type bounded-text
    return (
        !!selectedElement.value?.sourceElement ||
        (sources.value.length && selectedElement.value?.type === 'bounded-text')
    );
});

const isMaskedImage = computed(() => {
    return props.item.element.type === 'image-placeholder' && props.item.element.hasTextMask;
});

const onLinkButtonClick = () => {
    showLinkModal.value = true;
};

const closeLinkModal = () => {
    showLinkModal.value = false;
};

const handleApplyLink = (payload: {
    sourceElement: CanvasElement;
    sourceType: ElementType;
    valueFormat: ValueFormat;
}) => {
    onApplyLink(payload);
    closeLinkModal();
};

const handleUnlink = () => {
    onUnlink();
    closeLinkModal();
};

return { __sfc: true,props, flags, isVisible, isLocked, onElementTitleChange, onVisibilityClick, onLockClick, onApplyLink, onUnlink, showLinkModal, selectedElement, isPreviewStep, canChangeElementLock, canChangeElementVisibility, onLayerVisibilityClick, onLayerLockClick, isElementSolidBackground, elementTitle, getElementIcon, sources, showLinkButton, isMaskedImage, onLinkButtonClick, closeLinkModal, handleApplyLink, handleUnlink, SvgIcon, EditableText, CLazy, BaseLayersTreeItem, CButton, ElementsLinkModal }
}

})